export function tooltipPosition(
  pointer: { x: number; y: number },
  size: { width: number; height: number },
  viewport: { width: number; height: number },
) {
  const gap = 12,
    inset = 8;
  const x = pointer.x + gap + size.width <= viewport.width - inset ? pointer.x + gap : pointer.x - gap - size.width;
  const y = pointer.y + gap + size.height <= viewport.height - inset ? pointer.y + gap : pointer.y - gap - size.height;
  return {
    x: Math.max(inset, Math.min(x, viewport.width - size.width - inset)),
    y: Math.max(inset, Math.min(y, viewport.height - size.height - inset)),
  };
}
